import { Pipe, PipeTransform } from '@angular/core';
import { AssetStatus } from '@nusign/picflow-backend-types';

export const assetStatusOrder: AssetStatus[] = ['rejected', 'needs_review', 'in_progress', 'approved', 'no_status'];
export const assetStatusOrderFlipped: AssetStatus[] = [
  'approved',
  'in_progress',
  'needs_review',
  'rejected',
  'no_status',
];

@Pipe({
  name: 'assetStatusOrder',
  standalone: true,
})
export class AssetStatusOrderPipe implements PipeTransform {
  transform(statuses: AssetStatus[], flipped = false): AssetStatus[] {
    const sortedStatuses = flipped ? assetStatusOrderFlipped : assetStatusOrder;
    if (!sortedStatuses) return sortedStatuses; // temp before the backend adds the enabled statuses list
    return sortedStatuses.filter(s => statuses.includes(s));
  }
}
